// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as SecondaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SecondaryButton.bs.js";

function AllocationCampaignFooterCmp(Props) {
  var onLeftBtnClick = Props.onLeftBtnClick;
  var leftBtnText = Props.leftBtnText;
  var onRightBtnClick = Props.onRightBtnClick;
  var rightBtnText = Props.rightBtnText;
  return React.createElement("div", {
              className: "c-ald-create-campaign-footer-container"
            }, React.createElement("div", {
                  className: "c-ald-create-campaign-footer"
                }, leftBtnText !== "" ? React.createElement(SecondaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Text */0,
                              _0: leftBtnText
                            }, false, (function (_event) {
                                return Curry._1(onLeftBtnClick, undefined);
                              }), undefined, undefined, undefined, undefined, "left-button", undefined, undefined)
                      }) : null, rightBtnText !== "" ? React.createElement(PrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Text */0,
                              _0: rightBtnText
                            }, false, (function (_event) {
                                return Curry._1(onRightBtnClick, undefined);
                              }), undefined, undefined, undefined, undefined, "right-button", undefined, undefined)
                      }) : null));
}

var make = AllocationCampaignFooterCmp;

export {
  make ,
  
}
/* react Not a pure module */
